export default "__VITE_ASSET__BjkqMUOQ__"